import React, { useEffect, useState } from 'react';
import { formatClock } from '../utils/checkout';
const START_SECONDS = 17 * 60 + 34;
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const [hours, minutes, seconds] = formatClock(remaining);
  const units: Array<[string, string]> = [[hours, 'Hrs'], [minutes, 'Min'], [seconds, 'Sec']];
  return <div className="flex w-full flex-col items-center" data-id="element-20" data-mp="1ach88bspvw1y">
      <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-red-400 sm:text-xs" data-id="element-21" data-mp="1aczfs4ktxwp6">
        This price expires in
      </p>
      <div className="mt-2 flex items-center gap-2" role="timer" aria-live="off" aria-label={`Offer expires in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-22" data-mp="34qs1qxk9bee2">
        {units.map(([value, label], index) => <React.Fragment key={label} data-id="element-23" data-mp="1bz3vmtnfu6tx" data-mpi={index}>
            {index > 0 && <span className="text-xl font-bold text-gold-500" data-id="element-24" data-mp="1h0b1uo9xmxyh">:</span>}
            <div className="flex min-w-[56px] flex-col items-center rounded-lg border border-gold-500/40 bg-navy-900 px-2 py-2" data-id="element-25" data-mp="1gxf4b11zybak">
              <span className="font-display text-2xl font-bold tabular-nums text-white sm:text-3xl" data-id="element-26" data-mp="1712bs6i6u3he">
                {value}
              </span>
              <span className="text-[9px] font-semibold uppercase tracking-[0.16em] text-slate-400" data-id="element-27" data-mp="1ury9tld8lux3">
                {label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}